import { renderTooltip } from '@/lib/tooltip/tooltip'

export default {
  install: app => {
    app.config.globalProperties.$renderTooltip = (
      event,
      msg,
      shouldRender = true
    ) => {
      renderTooltip(event, msg, shouldRender)
    }
  },
}
